import React, { Component } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig'
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Loader } from '@jutro/components';
import { isCapabilityEnabled } from 'gw-portals-config-js';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import styles from './ProfileManager.module.scss';
import metadata from './ProfileManager.metadata.json5';
import messages from '../../Admins.messages';


class ProfileManager extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
    };

    state = {
        policyResponse: {},
        isLoading: false,
   };

    componentDidMount() {
//        this.getBillingDetails();
    }

    render() {
        //console.log(this.props);
        const {
            policyResponse,
            isLoading,
        } = this.state;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        // if (_.isEmpty(policyResponse)) {
        //     return null;
        // }
        const overrides = {
        };

        const resolvers = {
            resolveComponentMap: {},
            resolveCallbackMap: {
            },
            resolveClassNameMap: styles.profilemanager
        };
  
        const policyDetailsData = {
            policyResponse: policyResponse,
            getUpdateCountInfo: this.updateCountInfo,
        };
        return (
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={policyResponse}
                    overrideProps={overrides}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
        );
    }
}

export default withRouter(withAuthenticationContext(ProfileManager));
